<template>
    <Modal
        v-bind="$attrs"
        v-on="$listeners"
        :value="value"
        class-name="modal-container"
        :width="width"
        @input="onInput"
    >
        <p slot="header" class="header-class">
            <Icon type="ios-alert" color="#FFAE12" size="24" />
            <span class="title">提示</span>
        </p>
        <div style="text-align:center" class="body-class">
            <p class="text">{{text}}</p>
        </div>
        <div slot="footer" style="text-align:center;padding: 15px 0px;">
            <Button
                class="btn btn-confirm"
                :loading="modal_loading"
                @click="comfirm"
                :style="{'background': btnColor}"
            >{{btnText}}</Button>
        </div>
    </Modal>
</template>

<script>
export default {
    name: "Alter",

    inheritAttrs: false,

    data() {
        return {
            modal_loading: false,
        };
    },
    props: {
        text: {
            type: String,
            default: "提示的内容",
        },
        btnText: {
            type: String,
            default: "我知道了",
        },
        btnColor: {
            type: String,
            default: "",
        },
        value: {
            type: Boolean,
            default: false,
        },
        width: {
            type: String,
            default: "420px",
        },
    },
    methods: {
        onInput(val) {
            this.$emit("input", val);
        },
        comfirm() {
            this.$emit("closeAlter");
        },
    },
};
</script>

<style lang="less" scoped>
.header-class {
    text-align: center;
    font-size: 18px;
    border: none;
    height: 60px;
    line-height: 90px;
    .title {
        margin-left: 10px;
        font-size: 18px;
        font-weight: 400;
        color: rgb(170, 170, 170);
    }
}
.body-class {
    .text {
        font-size: 18px;
        font-weight: 400;
        text-align: left;
        color: rgb(51, 51, 51);
        text-align: center;
    }
}
.btn {
    width: 135px;
    height: 32px;
    &-confirm {
        background-color: @primary-color;
        color: #ffffff;
    }
}
</style>
<style lang="less">
// 居中
.modal-container {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 240px;
    .ivu-modal {
        top: 0;
    }
    // 去除边框
    .ivu-modal-header,
    .ivu-modal-footer {
        border: none !important;
    }
}
</style>